import { Fragment, type ReactNode } from "react";

export function KeyValues({ pairs, flat }: { pairs: Array<[ReactNode, ReactNode]>; flat?: boolean }) {
  return (
    <dl className={`kv${flat ? " kv-flat" : ""}`}>
      {pairs.map(([k, v], i) => (
        <Fragment key={i}>
          <dt>{k}</dt>
          <dd>{v}</dd>
        </Fragment>
      ))}
    </dl>
  );
}
